module.exports = __webpack_public_path__ + "img/Adobe Dreamweaver CC_Silicon Stone Education_20200324.6f37bbc7.jpg";